import LogList from 'common/pages/log/LogList.tsx'

export const LogListAgency = (props: any) => <LogList {...props} />